import React, { useEffect, useState } from "react";
import Otherlink from '../components/Otherlink';
import { useNavigate } from "react-router-dom";
import Select from "react-select";
import axios from "axios";
import AsyncSelect from 'react-select/async';
import MaskedInput from "react-text-mask";
import { baseUrl } from "../index";


const Travelform = () => {
    let navigate = useNavigate();
    const letsVisit = () => {
        if (Step === 3 && Travellers.some(item => item.dob === "" || item.dob === null || item.dob === undefined || getAge(item.dob) < 0) ) {            
            setDobError("Enter Valid Date Of Birth");
            setStep(3);
            return;
        }
        if (Step === 3) {
            const tripType = destination.length === 1 ? "Single" : "Annual Multi trip";
            // Set state in localStorage
            const quotationState = {
                MobileNo,
                destination: destination.map(i => i.label),
                startDate: convertDateFormat(startDate),
                endDate: convertDateFormat(endDate),
                Travellers,
                numberofDays,
                TripType: tripType,
                PolicyType: Travellers.length === 1 ? "Individual" : "Family"
            };

            sessionStorage.setItem('quotationState', JSON.stringify(quotationState));

            // Navigate to '/Quotation' page
            navigate("/Quotation", {
                state: quotationState
            });
            //console.log("state", destination);
        }
    };
    const [Step, setStep] = useState(1);
    const [destination, setDestination] = useState([]); 
    const [startDate, setStartDate] = useState("");
    const [endDate, setEndDate] = useState("");
    const [numberofDays, setNumberofDays] = useState(null);
    const [MobileNo, setMobileNo] = useState('');
    const [BtnDisabled, setBtnDisabled] = useState(true);
    const [Dob, setDob] = useState("");
    const [age, setAge] = useState('');
    const [Travellers, setTravellers] = useState([{ dob: '', age: '' }]);
    const [startDateError, setStartDateError] = useState("");
    const [endDateError, setEndDateError] = useState("");
    const [countries, setCountries] = useState([]);
     const [DobError, setDobError] = useState("");


    const countriesData = [
        { value: 1, label: "Canada" },
        { value: 2, label: "Switzerland" },
        { value: 3, label: "Malaysia" },
        { value: 4, label: "Turkey" },
        { value: 5, label: "United States" },
        { value: 6, label: "France" },
        { value: 7, label: "Great Britain" },
        { value: 8, label: "Spain" },
        { value: 9, label: "Maldives" },
        { value: 10, label: "Germany" },
    ];
    useEffect(() => {
        const fetchCountries = async () => {
            try {
                const response = await axios.post(`${baseUrl}/services/call`, {
                    URL: `/Master/GetCountries`,
                    PostString: JSON.stringify([]),
                });
                console.log(response?.data?.Response);
                const countriesData = response?.data?.Response?.map((item) => ({
                    label: item.CountryName,
                    value: item.Id,
                }));
                
                setCountries(countriesData);
            } catch (error) {
                console.error("Error fetching data:", error);
            }
        };
        fetchCountries();
    }, []);



    const promiseOptions = async (inputValue) => {
        if (inputValue && inputValue?.length >2) {
        
            try {
                let body =
                    [inputValue]

                var objIn = {
                    URL: `/Master/GetCountries`,
                    PostString: JSON.stringify(body)
                };
                const response = await axios.post(`${baseUrl}/services/call`, objIn);
                console.log("fetching data:", response);
                const options = mappData(response.data.response);
              
                return Promise.resolve(options);
            } catch (error) {
                //console.error("Error fetching data:", error);
                return Promise.resolve([]);
            }  }
    };

    const mappData = (data) => {
        let result = data.map(item => {
            return {
                label: item.countryName,
                value: item.id
            }
        })
        return result
    }

    //const onCoutryClick = (data) => {
    //    setDestination((prev) => ([
    //        ...prev,
    //        data
    //    ]))
    //}

    const onCoutryClick = (selectedCountry) => {
        setDestination((prev) => {
            // Prevent duplicates
            const exists = prev.some(item => item.value === selectedCountry.value);
            if (!exists) {
                return [...prev, selectedCountry];
            }
            return prev;
        });
    };

    //const handleChange = (destination, type) => {
    //    console.log(destination, type);
    //    if (type.action === 'remove-value' || type.action === 'pop-value') {
    //        const removedOption = type.removedValue;
    //        removeChip(removedOption);
    //    } else {
    //        setDestination(destination);
    //    }

    //};
    const handleChange = (destination, type) => {
        console.log(destination, type);
        if (type.action === 'remove-value' || type.action === 'pop-value') {
            const removedOption = type.removedValue;
            removeChip(removedOption);
        } else {
            setDestination(destination);
        }
    };
    //const handleCountryChange = (option) => {
    //    setDestination((prev) => [...prev, option]);
    //    console.log(destination);
    //};
    const removeChip = (removedValue) => {
        setDestination((prev) =>
            prev.filter((item) => item.value !== removedValue.value)
        );
    };
    useEffect(() => {
        if (startDate && endDate) {
            const start = new Date(startDate);
            const end = new Date(endDate);
            const timeDifference = end.getTime() - start.getTime() + (24 * 60 * 60 * 1000);
            const daysDifference = Math.floor(timeDifference / (1000 * 60 * 60 * 24));
            setNumberofDays(daysDifference);
        } else {
            setNumberofDays(null);
        }
    }, [startDate, endDate]);

    useEffect(() => {
        if (Step === 1 && (MobileNo !== "" && Array.isArray(destination) && destination.length)) {
            setBtnDisabled(false);
        }
        else if (Step === 2 && (startDate !== "" && endDate !== ""&& endDateError ==="")) {
            setBtnDisabled(false);
        }
        else if (Step === 2 && endDateError ==="") {
            setBtnDisabled(true);
        }
        else if (Step === 3 && (traveller => traveller.dob !== '' || traveller.age !== '')) {
            setBtnDisabled(false);
        }
        else {
            setBtnDisabled(true);
        }
    }, [Step, MobileNo, destination, startDate, endDate, Dob])

    const convertDateFormat = (dateString) => {
        const [year, month, day] = dateString.split("-");
        return `${day}-${month}-${year}`;
    };

    const getAge = (dateString) => {
        if (dateString !== undefined && dateString !== '') {
            let today = new Date();
            let birthDate = new Date(dateString);
            let age = today.getFullYear() - birthDate.getFullYear();
            let m = today.getMonth() - birthDate.getMonth();
            if (m < 0 || (m === 0 && today.getDate() < birthDate.getDate())) {
                return age - 1;
            }
            return age;
        }
    }
    const handleDateChange = (index, e) => {
        const newDob = e.target.value;
        const updatedTravelers = [...Travellers];
        const age = getAge(newDob);
        updatedTravelers[index] = { ...updatedTravelers[index], dob: newDob, age: age };
        setTravellers(updatedTravelers);
    };
    const Addtraveller = () => {
        if (Travellers.length <= 10) {
            setTravellers([...Travellers, { dob: '', age: '' }]);
        }
    }

    const handle = (e, index) => {

        let TravellerPersons = Travellers.map((row, ind) => ind === index ? { ...row, [e.target.name]: e.target.value, age: getAge(e.target.value) } : row);
        setTravellers(TravellerPersons);

        if (Travellers.some(item => item.dob === "" || item.dob === null || item.dob === undefined || getAge(item.dob) < 0)) {
            setDobError("Enter Valid Date Of Birth");
        } else {
            setDobError("");
        }

    }

    const removeTraveler = (index) => {
        if (Travellers.length > 1) {
            setTravellers((prevTravellers) => prevTravellers.filter((_, i) => i !== index));
        }
    };

    const HandleStartDate = (date) => {
        const currentDate = new Date();
        currentDate.setHours(0, 0, 0, 0);
        const selectedDate = new Date(date);

        const maxDate = new Date();
        maxDate.setDate(currentDate.getDate() + 364);

        if (selectedDate < currentDate) {
            setStartDateError("Selected date cannot be in the past");
        } else if (selectedDate > maxDate) {
            setStartDateError("Selected date cannot be more than 365 days from today");
        } else {
            setStartDateError("");
            setStartDate(date);
        }
    }; 
    const HandleEndDate = (date) => {
        const selectedDate = new Date(date);
        const startDateObject = new Date(startDate);

        const maxDate = new Date();
        maxDate.setDate(startDateObject.getDate() + 729);
        if (selectedDate < startDateObject) {
            setEndDateError("End date cannot be before start date.");
            setEndDate(date);
        } else if (selectedDate > maxDate) {
            setEndDateError("Selected date cannot be more than 730 days from start date");
            setEndDate(date);
        } else {
            setEndDateError("");
            setEndDate(date);
        }
    };

return (
    <div className="Travel-Form">
        {(Step === 2 || Step === 3) && (
            <div className="jusrnny_summry">
                <i className="fa fa-arrow-left"></i>
                <span>Destination:
                    {destination.map((dest, index) => (
                        <span key={index}>{dest.label}{index < destination.length - 1 ? ', ' : ''}</span>
                    ))}
                

                {/*<span>Destination: {destination.map(destination => <span>{destination.label}</span>)}*/}
                    {Step === 3 && <>, <span>{startDate}</span> to <span>{endDate}</span></>}
                </span>
            </div>
        )}
        {Step === 1 &&
            <div>
                <h4>Where are you planning to go?</h4>
                <div className="input-wrap Trav-fm">
                    <MaskedInput className="textdemo"
                        mask={[
                            /[6-9]/,
                            /\d/,
                            /\d/,
                            /\d/,
                            /\d/,
                            /\d/,
                            /\d/,
                            /\d/,
                            /\d/,
                            /\d/,
                        ]}
                        guide={false}
                        showMask={false}
                        type="text"
                        id="mobile"
                        name="mobile" value={MobileNo}
                        placeholder=" "
                        maxLength="10" autoComplete="off" onChange={(e) => setMobileNo(e.target.value)} />
                    <label className="demo-label">Mobile Number</label>
                </div>
                <div>
                    <span>Enter Destination</span>
                    <Select
                        isMulti
                        value={destination}
                        options={countries}
                        onChange={handleChange}
                    />
                    {/*<AsyncSelect isMulti*/}
                    {/*    cacheOptions*/}
                    {/*    value={destination}*/}
                    {/*    defaultOptions*/}
                    {/*    loadOptions={promiseOptions}*/}
                    {/*    onChange={handleChange}*/}
                    {/*/>*/}
                    <span className="Origin">Point of origin should be India</span>
                </div>
                <div className="mt-3">
                    <h5>Popular Countries</h5>
                    <ul className="TRVcontry">
                        {countriesData.map(item => (
                            <li key={item.value} onClick={() => onCoutryClick(item)}>
                                {item.label}
                            </li>
                        ))}

                    </ul>
                </div>
            </div>
        }

        {Step === 2 &&
            <div>
                <h4>What are your travelling dates?</h4>
                <div className="input-wrap form_margn">
                    <input type="date" className="textdemo" value={startDate} name="startdate" onChange={(e) => HandleStartDate(e.target.value)} placeholder=" "
                        min={new Date().toISOString().split('T')[0]}
                        max={new Date(new Date().setDate(new Date().getDate() + 364)).toISOString().split('T')[0]}  />
                    <label className="demo-label">Start Date</label>
                    {startDateError && <span className="error-message">{startDateError}</span>}
                </div>
                <div className="input-wrap form_margn">
                    <input type="date" className="textdemo" value={endDate} name="enddate" onChange={(e) => HandleEndDate(e.target.value)} placeholder=" "
                        min={startDate}
                    />
                    <label className="demo-label">End Date</label>
                    {endDateError && <span className="error-message">{endDateError}</span>}
                </div>
                {(numberofDays !== null && !isNaN(numberofDays)) &&
                    <span className="travel_calcu">Duration of the trip: {numberofDays}</span>
                }
            </div>
        }
        {Step === 3 &&
            <div>
                <h4>Enter traveller details</h4>
                <div className={Travellers.length > 1 ? "MoreTraveler": "" }>
                {Travellers.map((traveller, index) =>
                    <div key={index} className="Traveler_AGE">
                        <p>{`Traveller ${index + 1}`}</p>
                        <div className="d-flex mt-4">
                            <div className="input-wrap">
                                <input type="date" className="textdemo" value={traveller.dob} name="dob" placeholder=" " onChange={(e) => handle(e, index)} />
                                <label className="demo-label">Date of Birth</label>
                                {DobError && <span className="error-message">{DobError}</span>}
                            </div>
                            <span className="Trav_OR">OR</span>
                            <div className="input-wrap">
                                <input type="text" className="textdemo" value={getAge(traveller.dob)} placeholder=" " readOnly />
                                <label className="demo-label">Age (in years)</label>
                            </div>
                            <div onClick={() => removeTraveler(index)}><i className="fas fa-times-circle"></i></div>
                        </div>
                    </div>
                    )}
                </div>
                <div className="text-center">
                    <button className="AddTraveller-btn" onClick={() => Addtraveller()}>Add Traveller <i className="fa fa-plus ADDTRA-BTN"></i></button>
                </div>
            </div>}
        <div>
            <button className="TraveL-BTN" onClick={() => { setStep(Step + 1); letsVisit() }} disabled={BtnDisabled}>Next</button>
        </div>
        <Otherlink />
    </div>
);
}
export default Travelform;